import './main.css'

import { LoadingOutlined } from '@ant-design/icons';
import { Space, Spin } from 'antd';
import { useLocation,useNavigate  } from "react-router-dom";

import { useEffect, useState } from 'react';


function SPConnectAPP(){

    
    const [loading, setLoading] = useState()
    const [data, setData] = useState({})

    const [error, setError] = useState()

    const navigate = useNavigate();
    
    useEffect(() => {

        
        const core_url = new URL(window.location.href);
        const localToken = localStorage.getItem("token");

        let shop =  core_url.searchParams.get('shop');
        shop = shop.replace(".myshopify.com", "")
        const statePayload = localToken;
        const state = statePayload;
        // let rdr= "https://app.instantdm.com/shopfy-rdr"
        let rdr = "https://4iav7nkzgsu2jbpidrdt7seiri0lcfhk.lambda-url.ap-south-1.on.aws/shopify-store-connect"
        let client_id = "fc5d41556baf89d435f72d218f47f50f"
        let scopes = "read_orders,read_products,read_customers,read_discounts,read_shipping,write_draft_orders,write_orders"
        let url = `https://admin.shopify.com/store/${shop}/oauth/authorize?client_id=${client_id}&scope=${scopes}&redirect_uri=${rdr}&state=${state}`
        window.location.href = url;
        // console.log("-=-=-=-url-=--", url)
    },[])
    




    return(
        <div className='fb-rdr'>
            <p>Loading...</p>
        </div>
    )
}
export default SPConnectAPP;